import {Reward} from '@/types/promotion'

// Builds a rewards update targeting a single reward index; mergePromotionConditions merges rewards by index
export const toRewardsUpdate = (reward: Reward, rewardIndex = 0): Reward[] =>
  Object.assign([] as Reward[], {[rewardIndex]: reward})
